exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".preview-label:hover{cursor:pointer;filter:brightness(1.2)}\n", ""]);

// exports
